import React from "react";
import Header from "../../Layout/Header";
import HeaderLayout from "../../Layout/HeaderLayout";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowUpLong, faChevronDown, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const SelectNetwork = ({ setSelectNetwork }) => {

    const Choose_Network = [
        {
            photo: "https://s2.coinmarketcap.com/static/img/coins/64x64/8497.png",
            network_name: "Apeswap Finance",
            price: 1.98,
            change: "+3.4%",
            balance: "1,987.5 BANANA",
            total_value: "$3,865.86"
        },
        {
            photo: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
            network_name: "Bitcoin",
            price: 49_856.32,
            change: "+1.2%",
            balance: "0.052 BTC",
            total_value: "$2,592.52"
        },
        {
            photo: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            network_name: "Ethereum",
            price: 3_589.74,
            change: "-0.8%",
            balance: "1.25 ETH",
            total_value: "$4,487.18"
        }
    ];

    return (
        <div className="bg-[#060606] relative h-screen overflow-hidden overflow-y-auto text-white font-poppins ">
            {/* <HeaderLayout  /> */}
            <div
                className=" absolute -top-[20rem] left-0 right-0 w-[90%] mx-auto h-screen opacity-30 z-0"
                style={{
                    background:
                        "radial-gradient(50% 50% at 50% 50%, #FFF2C2 0%, rgba(0, 0, 0, 0) 100%)",
                }}
            ></div>
            <div className="relative space-y-5">
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 mt-10 w-[100%] md:w-[85%] mx-auto ">
                    <div className="rounded-lg p-5 bg-[#D9D9D926]">
                        <div className="flex justify-between">
                            <button className="font-medium text-xl">Wallet 1 <FontAwesomeIcon icon={faChevronDown} className="ml-1 text-xs" /></button>
                            <button className="text-xs bg-white/5 rounded-full px-3">Add wallet +</button>
                        </div>
                        <h1 className="font-Artemus text-3xl mt-2 truncate">$ 0</h1>
                    </div>
                    <div className="rounded-lg p-2 bg-[#D9D9D926]" >
                        <div className="flex justify-center gap-1 items-center text-xl font-medium">
                            Send <img src="/assets/other/arrowup.svg"></img>
                        </div>
                    </div>
                    <div className="rounded-lg p-2 bg-[#D9D9D926]">
                        <div className="flex justify-center gap-1 items-center text-xl font-medium">
                            Receive <img src="/assets/other/arrowup.svg" className="rotate-180"></img>
                        </div>
                    </div>
                </div>
                <div className="w-[100%] md:w-[85%] mx-auto bg-[#D9D9D924] border border-[#424242]  rounded-md  flex items-center justify-between">
                    <input type="search" className="w-[100%] px-5 py-3 bg-transparent outline-none" placeholder="Search network"></input>
                    <FontAwesomeIcon icon={faMagnifyingGlass} className="mr-3 text-white/50" />
                </div>
                <div className='space-y-3 w-[100%] md:w-[85%] mx-auto font-IBM'>
                    {Choose_Network.map((item, index) => (
                        <div key={index} className="bg-[#856E4F57] rounded-lg p-5 flex flex-col md:flex-row gap-5 md:gap-0 items-center justify-between">
                            <div className="flex gap-3 items-center">
                                <img src={item.photo} className="w-10 h-10 rounded-full"></img>
                                <div>
                                    <h1 className="font-medium">{item.network_name}</h1>
                                    <h2 className="text-xs">
                                        ${item.price} <span className={`ml-2 ${item.change.startsWith('-') ? 'text-red-400' : 'text-green-400'}`}>
                                            {item.change}
                                        </span>
                                    </h2>
                                </div>
                            </div>
                            <div className="grid md:text-end">
                                <h1 className="font-medium">{item.balance}</h1>
                                <h2 className="text-xs">{item.total_value}</h2>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SelectNetwork;